import { useMemo } from "react"
import { MultiSelect } from "primereact/multiselect"
import { useUsers } from "../../../../api/queries/useUsers"
import { InputNumber } from "primereact/inputnumber"
import { Divider } from "primereact/divider"

export default function CreateTaskPreventionSubForm({
  notificationUsers,
  handleNotificationUsersChange,
  notificationDays,
  handleNotificationDaysChange,
}) {
  const { data: users = [] } = useUsers()
  const usersWithEmail = useMemo(() => users.filter((user) => Boolean(user.email)), [users])

  return (
    <>
      <Divider className={"mt-6"}>Notifikace</Divider>

      <div className="p-fluid">
        <div className={"field"}>
          <label>Uživatelé:</label>
          <MultiSelect
            value={notificationUsers}
            options={usersWithEmail}
            optionValue={"uuid"}
            optionLabel={"name"}
            emptyMessage={"Žádné záznamy"}
            onChange={handleNotificationUsersChange}
            filter={true}
            filterBy="name"
          />
        </div>

        <div className={"field"}>
          <label>Upozornit dní předem:</label>
          <InputNumber
            value={notificationDays}
            min={1}
            step={1}
            onChange={handleNotificationDaysChange} />
        </div>
      </div>
    </>
  )
}
